import React from "react";
import moment from "moment/moment";
import * as Util from '../common/Util';
import {Link} from 'react-router-dom';
import InvalidAccessOrLogin from "../errorsPage/InvalidAccessOrLogin";

class Payment extends React.Component {

    constructor(params) {
        super(params);
        this.state = {
            payment: {recipient: {}, processorResult: {}},
            blubillingConf: {},
            apiStatus: {
                isError: false,
                message: ''
            },
            showLoader: false,
            redirectToNotFoundPage: false,
            redirectToForbiddenPage: false
        }
        this.fetchPayment = this.fetchPayment.bind(this)
    }

    fetchPayment(){
        console.log(this.props.params)
        if(this.props.params && this.props.params.id) {
            let url = this.props.api + "/payment/" + this.props.params.id;
            this.setState({showLoader:true});
            fetch(url,{

                method: 'GET',
                mode: 'cors',
                headers: {
                    'X-AUTH-TOKEN': this.props.jwtToken
                }
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json);
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.setState({showLoader: false});
                        this.props.onLogoutClick(json.message);
                    } else if (json.message === "Payment not found" && json.isError === true) {
                        this.setState({showLoader: false, redirectToNotFoundPage: true});
                    } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                        this.setState({showLoader: false, redirectToForbiddenPage: true});
                    } else {
                        if (json.payment) {
                            this.setState({payment: json.payment, showLoader: false});
                        } else {
                            const {apiStatus} = this.state
                            apiStatus.isError = true
                            apiStatus.message = json.message
                            this.setState({
                                payment: {recipient: {}, processorResult: {}},
                                showLoader: false,
                                apiStatus: apiStatus
                            });
                        }
                    }
                }).catch(error => {
                this.setState({showLoader:false});
                console.log(error);
            });
        }
    }

    componentDidMount() {
        this.fetchPayment();
    }

    render() {
        let _this = this;

        return (
            <div>
                <div className="wrapper wrapper-content" >
                    <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                          redirectToNotFoundPage={this.state.redirectToNotFoundPage}
                                          redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h5>{_this.props.msg('payment.detail')}</h5>
                                </div>
                                <div className="ibox-content">
                                    {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                                    <div style={{'textAlign':'center'}}>
                                                  <span
                                                      style={{'color':this.state.apiStatus.isError===true?'red':'green'}}> {this.state.apiStatus.message ? this.state.apiStatus.message : ''}</span>
                                        <br/>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="col-lg-6" style={{paddingLeft:"0px", paddingRight:"10px"}}>
                                                <h5 style={{color:"#006DBA",borderBottom:"3px solid #d1d1d1"}}>Signature Request Detail</h5>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt>Status:</dt>

                                                    {this.state.payment.status === "PAID" ?
                                                        <span
                                                            className="m-l-md label label-success text-uppercase" style={{marginLeft:'23px'}}>PAID</span>
                                                        :null}
                                                    {this.state.payment.status === "DRAFT" ?
                                                        <span
                                                            className="m-l-md label label-info text-uppercase" style={{marginLeft:'23px'}}>DRAFT</span>
                                                        :null}

                                                    {this.state.payment.status === "DECLINED" ?
                                                        <span
                                                            className="m-l-md label label-warning text-uppercase"style={{marginLeft:'23px'}}>DECLINED</span>
                                                        :null}

                                                    {this.state.payment.status === "ERROR" ?
                                                        <span
                                                            className="m-l-md label label-danger text-uppercase" style={{marginLeft:'23px'}}>ERROR</span>
                                                        :null}

                                                    {this.state.payment.status === "VOIDED" ?
                                                        <span
                                                            className="m-l-md label label-draft text-uppercase" style={{marginLeft:'23px'}}>VOIDED</span>
                                                        :null}

                                                    {this.state.payment.status === "REVERSED" ?
                                                        <span
                                                            className="m-l-md label label-default text-uppercase" style={{marginLeft:'23px'}}>REVERSED</span>
                                                        :null}
                                                </dl>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt>{_this.props.msg('payment.signatureRequest')}:</dt>
                                                    <dd className="">
                                                        <Link to={'/esignatureDetail/'+this.state.payment.signatureRequestId} target="_blank" title="View Signature Request" style={{textDecoration:"underline"}}>
                                                            {this.state.payment.signatureRequestTitle}
                                                        </Link>

                                                        </dd>

                                                    <dt>Recipient:</dt>
                                                    <dd>{this.state.payment.recipient ? this.state.payment.recipient.name : ''}</dd>

                                                    <dt>{_this.props.msg('table.th.email')}:</dt>
                                                    <dd>{this.state.payment.recipient ? this.state.payment.recipient.email : ''}</dd>


                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="col-lg-6" style={{paddingLeft:"0px", paddingRight:"10px"}}>
                                                <h5 style={{color:"#006DBA",borderBottom:"3px solid #d1d1d1"}}>Transaction Detail</h5>
                                                <dl className="dl-horizontal" style={{marginBottom:"2px"}}>
                                                    <dt>{_this.props.msg('payment.Id')}#:</dt>
                                                    <dd className="">{this.state.payment.id}</dd>

                                                    <dt>{_this.props.msg('payment.externalId')}#:</dt>
                                                    <dd>{this.state.payment.externalPaymentId}</dd>

                                                    <dt>{_this.props.msg('payment.amount')}:</dt>
                                                    <dd>$ {Util.formatMoney(this.state.payment.amount)}</dd>

                                                    <dt>{_this.props.msg('payment.effectiveDate')}:</dt>
                                                    <dd>{moment(this.state.payment.effectiveDate).format("MM/DD/YYYY")}</dd>

                                                    <dt>{_this.props.msg('payment.transactionDate')}:</dt>
                                                    <dd>{moment(this.state.payment.dateCreated).format("MM/DD/YYYY hh:mm")}</dd>

                                                    <dt>{_this.props.msg('payment.createdUser')}:</dt>
                                                    <dd>{this.state.payment.paymentUser && this.state.payment.paymentUser.username ? this.state.payment.paymentUser.username : ''}</dd>

                                                    <dt>{_this.props.msg('table.th.notes')}:</dt>
                                                    <dd>{this.state.payment.notes}</dd>
                                                    <dt>{_this.props.msg('table.th.paymentMethodType')}:</dt>
                                                    <dd>{this.state.payment.paymentMethodType}</dd>
                                                    <dt>{_this.props.msg('table.th.blubillingCustomer')}:</dt>
                                                        <dd><strong> {(this.state.payment.blubillingCustomer && this.state.payment.blubillingCustomer.companyName)? this.state.payment.blubillingCustomer.companyName:null}</strong>
                                                            {(this.state.payment.blubillingCustomer && this.state.payment.blubillingCustomer.firstName)?<p>{this.state.payment.blubillingCustomer.firstName}&nbsp;{(this.state.payment.blubillingCustomer && this.state.payment.blubillingCustomer.lastName)?this.state.payment.blubillingCustomer.lastName:null}</p>:null}
                                                            ({(this.state.payment.blubillingCustomer && this.state.payment.blubillingCustomer.email)? this.state.payment.blubillingCustomer.email:null})</dd>
                                                </dl>
                                            </div>
                                            <div className="col-lg-6" style={{paddingLeft:"0px", paddingRight:"0px"}}>
                                                <h5 style={{color:"#006DBA",borderBottom:"3px solid #d1d1d1"}}>Authorization Detail</h5>
                                                <dl className="dl-horizontal">
                                                    <dt>{_this.props.msg('payment.trnsactionType')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult ? this.state.payment.processorResult.processorRequestType : ''}
                                                    </dd>
                                                    <dt>{_this.props.msg('payment.result')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult && this.state.payment.processorResult.isError === true ? 'Error' : null}
                                                        {(this.state.payment.processorResult && this.state.payment.processorResult.isError !== true &&  this.state.payment.processorResult.isSuccess === true) ? 'Success' : null}
                                                        {(this.state.payment.processorResult && this.state.payment.processorResult.isError !== true &&  this.state.payment.processorResult.isSuccess !== true) ? 'Fail' : null}
                                                    </dd>

                                                    <dt>{_this.props.msg('payment.tranxId')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult ? this.state.payment.processorResult.transactionId : ''}
                                                    </dd>
                                                    <dt>{_this.props.msg('payment.approvalCode')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult?this.state.payment.processorResult.approvalCode:''}
                                                    </dd>
                                                    <dt>{_this.props.msg('payment.avsCode')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult?this.state.payment.processorResult.avsCode:''}
                                                    </dd>

                                                    <dt>{_this.props.msg('payment.cvvCode')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult?this.state.payment.processorResult.cvvCode:''}
                                                    </dd>
                                                    <dt>{_this.props.msg('payment.statusCode')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult?this.state.payment.processorResult.statusCode:''}
                                                    </dd>
                                                    <dt>{_this.props.msg('payment.messageStr')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult?this.state.payment.processorResult.statusMessage:''}
                                                    </dd>
                                                    <dt>{_this.props.msg('payment.errorStr')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult?this.state.payment.processorResult.errorMessage:''}
                                                    </dd>
                                                    <dt>{_this.props.msg('payment.responseTime')}:</dt>
                                                    <dd>
                                                        {this.state.payment.processorResult?this.state.payment.processorResult.responseTimeMilliSec:'0'} msec.
                                                    </dd>
                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style dangerouslySetInnerHTML = {{__html: `
                p { margin:0 0 2px;}
                .table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
                  padding: 4px;
                }

                .center{ text-align:center }
                .left{ text-align:left }
                .right{ text-align:right }
                dt{padding: 2px;}
                dd{padding: 2px;}
                `}} />
            </div>
        )
    }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/components/payment/Payment.js